import {
  allBaseSymbols,
  BaseSymbol,
} from '@ui/assets/config/trade-pair-listings';
import { DEFAULT_CHAIN_ID } from '@ui/constants/chain';
import { TokenSymbol } from '@ui/constants/tokens';
import { ChainId } from '@ui/types/chain';

export const STATIC_SUPPORTED_SYMBOLS = [
  'USDC',
  'LVUSD',
  'LVMON',
  'MON',
] as const;
export const HERMS_SUPPORTED_SYMBOLS = [
  ...allBaseSymbols,
  ...STATIC_SUPPORTED_SYMBOLS,
] satisfies (BaseSymbol | TokenSymbol)[];

export type HermsSupportedSymbol = (typeof HERMS_SUPPORTED_SYMBOLS)[number];
export type StaticSupportedSymbol = (typeof STATIC_SUPPORTED_SYMBOLS)[number];

let MON_PYTH_FEE_ID = '0x31491744e2dbf6df7fcf4ac0820d18a609b49076d45066d3568424e62f686cd1';

// get from here: https://www.pyth.network/developers/price-feed-ids#pyth-evm-stable
// rmb to remove 0x
export const SYMBOL_TO_HERMS_PRICE_ID: Record<StaticSupportedSymbol, string> = {
  USDC: '0xeaa020c61cc479712813461ce153894a96a6c00b21ed0cfc2798d1f9a9e9c94a',
  LVUSD: '0xeaa020c61cc479712813461ce153894a96a6c00b21ed0cfc2798d1f9a9e9c94a',
  LVMON: MON_PYTH_FEE_ID,
  MON: MON_PYTH_FEE_ID,
};